import { request } from '@umijs/max';
// 获取系统列表数据
export async function getSysParamService() {
  return request('/sysparams');
}
// 获取当前选中的tag
export async function getLevelService() {
  return request('/sysparams/securitylevel');
}
// 根据tag查询当前的详情
export async function getRuleService(params: any) {
  return request(`/sysparams/securityrules/${params}`);
}

// 弹框规则保存
export async function changeRuleService(data: any) {
  return request('/sysparams/securityrules', {
    method: 'PUT',
    data,
  });
}

// 行编辑保存
export async function changeSysParamService(data: any) {
  return request('/sysparams', {
    method: 'PUT',
    data,
  });
}
